// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".save-template[data-v-ef0b23ae]{height:100px}.ellipsis[data-v-ef0b23ae]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.searchIcon[data-v-ef0b23ae]{display:flex;align-items:center}.searchIcon>*[data-v-ef0b23ae]{cursor:pointer;margin-right:5px}.searchIcon .badge-light[data-v-ef0b23ae]{background-color:#6c757d;color:#fff}", ""]);
// Exports
module.exports = exports;
